import React, { useEffect, useState } from "react";
import { Button, Heading, MenuButton, Modal } from "../../components/Common";
import { Search, Pagination } from "../../components/Common/Table";
import { VscFilter } from "react-icons/vsc";
import {
  Box,
  Paper,
  Stack,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { MdMoreVert } from "react-icons/md";
import { HiOutlineTrash } from "react-icons/hi";
import { AiOutlineEdit } from "react-icons/ai";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import FilterLanguage from "./FilterLanguage";
import {
  LanguageList,
  LanguageDelete,
  LanguageStatusUpdate,
} from "../../Service/Language.service";
import {
  filterLanguageInitialValues,
} from "../../helper/initialValues";
import { useDispatch } from "react-redux";
import { notificationSuccess } from "../../state/Action/NotificationAction";
import { useFormik } from "formik";
import moment from "moment";
import TableRowsLoader from "../../components/Common/Loader/Skeleton";
import { IsDelete, IsWrite } from "../../helper/handlePermission";

const Language = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState({
    open: false,
    currentComponent: "",
  });

  const editPermissions = IsWrite("Language");
  const deletePermissions = IsDelete("Language");

  const [languageData, setLanguageData] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [search, setSearch] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });
  const dispatch = useDispatch();

  const formik1 = useFormik({
    initialValues: filterLanguageInitialValues,
    onSubmit: async (value) => {
      setOpenDrawer(false);
      getLanguageList();
    },
  });

  const getLanguageList = async () => {
    setLanguageData([]);
    let selectQry = `?page=${page + 1
      }&limit=${rowsPerPage}&search=${search}&status=${formik1.values.status
      }&sortBy=${sortConfig.key}&sortFlag=${sortConfig.direction
      }`;
    let res = await LanguageList(selectQry);
    if (res?.status) {
      setLanguageData(res.data);
      setTotalData(res.total);
    } else {
      setLanguageData(null);
    }
  };

  useEffect(() => {
    getLanguageList();
  }, [search, page, rowsPerPage, sortConfig]);

  const toggleDrawer = () => {
    setOpenDrawer(!openDrawer);
  };

  const changeStatus = async () => {
    let res =
      isModalOpen && isModalOpen?.currentComponent == "status"
        ? await LanguageStatusUpdate(isModalOpen?.id, { status: isModalOpen?.status === 1 ? 0 : 1 })
        : isModalOpen && isModalOpen?.currentComponent == "delete"
          ? await LanguageDelete(isModalOpen?.id)
          : null;
    if (res?.status) {
      dispatch(
        notificationSuccess({
          show: true,
          type: "success",
          message: res.message || "Success",
        })
      );
      getLanguageList();
      setIsModalOpen({
        open: false,
        currentComponent: "",
        para: "",
        head: "",
        id: "",
      });
    } else {
      dispatch(
        notificationSuccess({
          show: true,
          type: "error",
          message:
            res.message || "Something went wrong. Please try again later.",
        })
      );
    }
  };

  return (
    <>
      <Stack gap={2} mt={1}>
        <Stack
          mb={1}
          flexDirection={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Heading head={"Language"} />
          <Stack flexDirection={"row"} alignItems={"center"} gap={1}>
            <Search search={search} setSearch={setSearch} setPage={setPage} />
            {editPermissions && (
              <Button
                buttonName={"Add"}
                size="small"
                onClick={() => {
                  navigate("/addlanguage");
                }}
              />
            )}
            <Button
              buttonName={<VscFilter />}
              style={{ padding: "10px 11px" }}
              color="white"
              size="small"
              onClick={toggleDrawer}
              variant="contained"
            />
            <FilterLanguage
              openDrawer={openDrawer}
              toggleDrawer={toggleDrawer}
              formik={formik1}
            />
          </Stack>
        </Stack>
        <TableContainer component={Paper}>
          <Table stickyHeader aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{ cursor: "pointer", fontWeight: "bold", whiteSpace: "nowrap" }}
                  onClick={() =>
                    setSortConfig({
                      key: "languageName",
                      direction:
                        sortConfig &&
                          sortConfig.key === "languageName" &&
                          sortConfig.direction === "asc"
                          ? "desc"
                          : "asc",
                    })
                  }
                >
                  <Stack
                    flexDirection={"row"}
                    gap={0.5}
                    alignItems={"center"}
                    sx={{ width: "max-content", flexWrap: "nowrap" }}
                  >
                    Name
                    {sortConfig && sortConfig.key === "languageName" && sortConfig.direction === "desc" ? (
                      <IoIosArrowUp style={{ fontSize: "16px", color: "#6b7280" }} />
                    ) : (
                      <IoIosArrowDown style={{ fontSize: "16px", color: "#6b7280" }} />
                    )}
                  </Stack>
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}>Code</TableCell>
                <TableCell
                  sx={{ cursor: "pointer", fontWeight: "bold", whiteSpace: "nowrap", width: "200px", minWidth: "200px" }}
                  onClick={() =>
                    setSortConfig({
                      key: "createdAt",
                      direction:
                        sortConfig &&
                          sortConfig.key === "createdAt" &&
                          sortConfig.direction === "asc"
                          ? "desc"
                          : "asc",
                    })
                  }
                >
                  <Stack
                    flexDirection={"row"}
                    gap={0.5}
                    alignItems={"center"}
                    sx={{ width: "max-content", flexWrap: "nowrap" }}
                  >
                    Created Date
                    {sortConfig && sortConfig.key === "createdAt" && sortConfig.direction === "desc" ? (
                      <IoIosArrowUp style={{ fontSize: "16px", color: "#6b7280" }} />
                    ) : (
                      <IoIosArrowDown style={{ fontSize: "16px", color: "#6b7280" }} />
                    )}
                  </Stack>
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}>Status</TableCell>
                <TableCell align="right" sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {languageData &&
                languageData.map((data) => (
                  <TableRow
                    key={data._id}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                      cursor: "pointer",
                    }}
                  >
                    <TableCell>{data?.languageName}</TableCell>
                    <TableCell>{data?.languageCode}</TableCell>
                    <TableCell sx={{ whiteSpace: "nowrap" }}>{moment(data?.createdAt).format("DD/MM/YYYY")}</TableCell>
                    <TableCell>
                      <Switch
                        size="small"
                        checked={data?.status === 1 ? true : false}
                        disabled={formik1.values.status == 2}
                        onClick={(e) => {
                          e.stopPropagation();

                          if (editPermissions) {
                            setIsModalOpen({
                              id: data?._id,
                              status: data?.status,
                              open: true,
                              currentComponent: "status",
                              head: "Change Status",
                              para: "Are you sure you want to Change the Status?",
                            });
                          } else {
                            dispatch(
                              notificationSuccess({
                                show: true,
                                type: "error",
                                message:
                                  "You don't have permission to change status",
                              })
                            );
                          }
                        }}
                      />
                    </TableCell>
                    <TableCell align="right" onClick={(e) => e.stopPropagation()}>
                      <Stack direction="row" justifyContent="flex-end">
                        {editPermissions || deletePermissions ? (
                          <DropdownMenu.Root>
                            <DropdownMenu.Trigger className="chatDropDown">
                              <MenuButton
                                icon={
                                  <MdMoreVert
                                    style={{ color: "#000", fontSize: "18px" }}
                                  />
                                }
                                width="30px"
                                height="33px"
                              />
                            </DropdownMenu.Trigger>
                            <DropdownMenu.Content
                              className="chatDropDownContent"
                              align="end"
                            >
                              {editPermissions && (
                                <DropdownMenu.Item
                                  className="chatDropDownMenu"
                                  onClick={() => {
                                    navigate("/addlanguage", {
                                      state: { id: data?._id, isEdit: true },
                                    });
                                  }}
                                >
                                  <Stack
                                    flexDirection={"row"}
                                    gap={1}
                                    alignItems={"center"}
                                  >
                                    <AiOutlineEdit style={{ fontSize: "15px" }} />
                                    <Box sx={{ fontSize: "13px" }}>{"Edit"}</Box>
                                  </Stack>
                                </DropdownMenu.Item>
                              )}
                              {deletePermissions && (
                                <DropdownMenu.Item className="chatDropDownMenu">
                                  <Stack
                                    flexDirection={"row"}
                                    gap={1}
                                    alignItems={"center"}
                                    onClick={() =>
                                      setIsModalOpen({
                                        open: true,
                                        currentComponent: "delete",
                                        head: "Delete Language",
                                        para: "Are you sure you want to Delete this Language?",
                                        id: data?._id,
                                      })
                                    }
                                  >
                                    <HiOutlineTrash
                                      style={{ fontSize: "15px" }}
                                    />
                                    <Box sx={{ fontSize: "13px" }}>
                                      {"Delete"}
                                    </Box>
                                  </Stack>
                                </DropdownMenu.Item>
                              )}
                            </DropdownMenu.Content>
                          </DropdownMenu.Root>
                        ) : (
                          "-"
                        )}
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))}
              {languageData == null ? (
                <TableRow>
                  <TableCell
                    sx={{
                      color: "silver",
                      textAlign: "center",
                      paddingTop: "90px",
                      borderBottom: "none",
                      fontSize: "30px",
                    }}
                    colSpan={5}
                  >
                    No records to display
                  </TableCell>
                </TableRow>
              ) : languageData && languageData.length == 0 ? (
                <TableRowsLoader colNumber={5} rowsNum={10} />
              ) : (
                ""
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          {languageData != null && (
            <Pagination
              count={10}
              shape="rounded"
              totalData={totalData}
              page={page}
              setPage={setPage}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
            />
          )}
        </div>
      </Stack>
      <Modal
        modalOpen={isModalOpen}
        handleClose={() =>
          setIsModalOpen({ open: false, currentComponent: "" })
        }
        handelClick={changeStatus}
      />
    </>
  );
};

export default Language;
